import { Button, Tabs } from "antd";
import React from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ScreenRecording from "./ScreenRecording";
import TextRecording from "./TextRecording";
import { PageHeader, PageShell } from "../../../design-system/tableUi";

// Session recordings. Both tabs render inside this shell, so they use
// EmbeddedShell rather than their own page chrome.
//
// This screen is no longer a sidebar destination — it is always arrived at from
// somewhere: an endpoint's Recordings column, an endpoint user, a gateway's
// Sessions tab, or Step 3 of onboarding. So it needs a way back.
const SessionRecordings = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const endpoint = searchParams.get("endpoint");
  const epmUser = searchParams.get("epmUser");
  // ?session= comes from an SSH row on the Auth Logs page.
  const session = searchParams.get("session");

  // location.key is "default" only on the first entry in the history stack —
  // a bookmark, a pasted link, a hard reload. Going "back" from there would
  // leave the app entirely, so fall back to the screen this is scoped to.
  const canGoBack = location.key !== "default";
  const fallback = endpoint || epmUser ? "/pam/endpoint" : session ? "/pam/auth-logs" : "/pam/jumpServer";
  const label = endpoint
    ? "Back to Endpoints"
    : epmUser
    ? "Back to Endpoint Users"
    : session
    ? "Back to Access Logs"
    : "Back";

  const goBack = () => (canGoBack ? navigate(-1) : navigate(fallback));

  return (
    <PageShell>
      <PageHeader
        eyebrow={endpoint ? `PAM · Endpoints · ${endpoint}` : "PAM · Access Control"}
        title="Session Recordings"
        subtitle={
          endpoint
            ? `Sessions recorded on ${endpoint}.`
            : epmUser
            ? `Sessions recorded for ${epmUser}.`
            : session
            ? `Recording of SSH session ${session}.`
            : "What happened inside a session. A recording appearing here is the only positive proof a session opened — every refusal looks identical from the client."
        }
        actions={
          <Button onClick={goBack} icon={<ArrowLeft size={14} style={{ verticalAlign: -2, marginRight: 6 }} />}>
            {label}
          </Button>
        }
      />
      <Tabs
        items={[
          { key: "text", label: "Terminal", children: <TextRecording /> },
          { key: "screen", label: "Screen", children: <ScreenRecording /> },
        ]}
      />
    </PageShell>
  );
};

export default SessionRecordings;
